import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitButton']

  connect() {
    this.validate()
  }

  validate() {
    const fields = this.element.querySelectorAll('input:not([disabled]):not([type=hidden]), textarea:not([disabled])')
    const allFilled = Array.from(fields).every((field) => field.value.trim() !== '')

    this.submitButtonTargets.forEach((button) => {
      button.disabled = !allFilled
    })
  }
}
